import { LendingOpportunity } from '@/enterprise/data/fundboxOpportunityMappers';

export type MonduLendingOpportunity = Extract<LendingOpportunity, { provider: 'MONDU' }>;

/**
 * Picks the Mondu row out of `GET /user/lending-opportunities`.
 * Deliberately separate from the Fundbox mappers so a change made for one provider cannot reshape
 * the other provider's page.
 */
export const selectMonduLendingOpportunity = (
  opportunities: LendingOpportunity[]
): MonduLendingOpportunity | undefined =>
  opportunities.find((opportunity): opportunity is MonduLendingOpportunity => opportunity.provider === 'MONDU');

/**
 * Whether Mondu has already created a supplier for this opportunity.
 * `status` is not a substitute: an `IN_PROGRESS` row with no `providerApplicationId` is a
 * started-but-unfinished create, and that supplier has not been handed off yet.
 */
export const hasMonduSupplier = (opportunity: MonduLendingOpportunity | undefined): boolean =>
  Boolean(opportunity?.providerApplicationId);
